@let generateType = generateType$ | async;
@let showAlgorithm = showAlgorithm$ | async;
@let account = account$ | async;

<nudge-generator-spotlight></nudge-generator-spotlight>

<div class="bv-generator__output">
  <bit-color-password
    class="bv-generator__output-value"
    [password]="value$ | async"
  ></bit-color-password>
</div>

<section class="bv-generator__section">
  <h3 class="bv-generator__heading">{{ "whatWouldYouLikeToGenerate" | i18n }}</h3>
  <bit-radio-group
    class="bv-generator__radio-row"
    [ngModel]="generateType"
    (ngModelChange)="onGenerateTypeChange($event)"
  >
    <bit-radio-button value="password">
      <bit-label>{{ "password" | i18n }}</bit-label>
    </bit-radio-button>
    <bit-radio-button value="username">
      <bit-label>{{ "username" | i18n }}</bit-label>
    </bit-radio-button>
  </bit-radio-group>
</section>

@if (generateType === "password") {
  <section class="bv-generator__section">
    <h3 class="bv-generator__heading">{{ "passwordType" | i18n }}</h3>
    <bit-radio-group
      class="bv-generator__radio-row"
      [ngModel]="passwordSubtype$ | async"
      (ngModelChange)="onPasswordSubtypeChange($event)"
    >
      <bit-radio-button value="password">
        <bit-label>{{ "password" | i18n }}</bit-label>
      </bit-radio-button>
      <bit-radio-button value="passphrase">
        <bit-label>{{ "passphrase" | i18n }}</bit-label>
      </bit-radio-button>
    </bit-radio-group>
  </section>

  @if (showAlgorithm?.id === Algorithm.password) {
    <tools-password-settings
      [account]="account"
      [showHeader]="false"
      (onUpdated)="generate('password settings')"
    />
  }
  @if (showAlgorithm?.id === Algorithm.passphrase) {
    <tools-passphrase-settings
      [account]="account"
      [showHeader]="false"
      (onUpdated)="generate('passphrase settings')"
    />
  }
}

@if (generateType === "username") {
  <section class="bv-generator__section">
    <h3 class="bv-generator__heading bv-generator__heading--with-icon">
      {{ "usernameType" | i18n }}
      <i class="bwi bwi-question-circle bv-generator__help-icon" aria-hidden="true"></i>
    </h3>
    <form [formGroup]="username" class="bv-generator__username-options">
      <bit-radio-group formControlName="nav">
        @for (option of usernameOptions$ | async; track option.value) {
          <bit-radio-button [value]="option.value" class="bv-generator__username-option">
            <bit-label>{{ option.label }}</bit-label>
            @if (option.description) {
              <bit-hint>{{ option.description }}</bit-hint>
            }
          </bit-radio-button>
        }
      </bit-radio-group>
    </form>

    @if (showForwarder$ | async) {
      <form [formGroup]="forwarder" class="bv-generator__forwarder-form">
        <bit-form-field>
          <bit-label>{{ "service" | i18n }}</bit-label>
          <bit-select
            [items]="forwarderOptions$ | async"
            formControlName="nav"
            data-testid="email-forwarding-service"
          >
          </bit-select>
        </bit-form-field>
      </form>
    }

    @if (showAlgorithm?.id === Algorithm.catchall) {
      <tools-catchall-settings [account]="account" (onUpdated)="generate('catchall settings')" />
    }
    @if (forwarderId$ | async; as forwarderId) {
      <tools-forwarder-settings [account]="account" [forwarder]="forwarderId" />
    }
    @if (showAlgorithm?.id === Algorithm.plusAddress) {
      <tools-subaddress-settings
        [account]="account"
        (onUpdated)="generate('subaddress settings')"
      />
    }
    @if (showAlgorithm?.id === Algorithm.username) {
      <section class="bv-generator__section bv-generator__section--options">
        <h3 class="bv-generator__heading">{{ "options" | i18n }}</h3>
        <tools-username-settings [account]="account" (onUpdated)="generate('username settings')" />
      </section>
    }
  </section>
}

<div class="bv-generator__footer">
  <div class="bv-generator__actions">
    <button
      type="button"
      bitButton
      buttonType="primary"
      class="bv-generator__regenerate-btn"
      (click)="generate(USER_REQUEST)"
      [disabled]="!(algorithm$ | async)"
    >
      {{ regenerateLabel$ | async }}
    </button>
    <button
      type="button"
      bitButton
      buttonType="secondary"
      class="bv-generator__copy-btn"
      showToast
      [attr.aria-label]="credentialTypeCopyLabel$ | async"
      [appCopyClick]="value$ | async"
      [valueLabel]="credentialTypeLabel$ | async"
      [disabled]="!(algorithm$ | async)"
    >
      {{ credentialTypeCopyLabel$ | async }}
    </button>
  </div>
  <button
    type="button"
    class="bv-generator__history-btn"
    (click)="onHistoryClick()"
    aria-haspopup="dialog"
  >
    <span class="bv-generator__history-label">{{ historyLabel$ | async }}</span>
    <span class="bv-generator__history-icon" aria-hidden="true"></span>
  </button>
</div>
